"use client";

import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { ReactElement } from "react";
import {
  FcAbout,
  FcAssistant,
  FcCollaboration,
  FcDonate,
  FcInTransit,
  FcManager,
} from "react-icons/fc";
import Layout from "../../../layout/Layout";
import { ApiCard } from "../../../components/card";

export default function RouteHome() {
  return (
    <Layout
      children={
        <Box p={4}>
          <Stack spacing={4} as={Container} maxW={"3xl"} textAlign={"center"}>
            <Heading fontSize={{ base: "2xl", sm: "4xl" }} fontWeight={"bold"}>
              Route APIs
            </Heading>
            <Text color={"gray.600"} fontSize={{ base: "sm", sm: "lg" }}>
              Optimize delivery routes, improve driver efficiency, reduce costs
              and enhance customer satisfaction with our robust Route APIs.
            </Text>
          </Stack>

          <Container maxW={"5xl"} mt={12}>
            <Flex flexWrap="wrap" gridGap={6} justify="center">
              {/* <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Routing"}
                  icon={<Icon as={FcAssistant} w={10} h={10} />}
                  description={
                    "Lorem ipsum dolor sit amet catetur, adipisicing elit."
                  }
                  href={"/route/routing"}
                />
              </Box>
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Route Matrix"}
                  icon={<Icon as={FcCollaboration} w={10} h={10} />}
                  description={
                    "Lorem ipsum dolor sit amet catetur, adipisicing elit."
                  }
                  href={"#"}
                />
              </Box>
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Map Matching"}
                  icon={<Icon as={FcDonate} w={10} h={10} />}
                  description={
                    "Lorem ipsum dolor sit amet catetur, adipisicing elit."
                  }
                  href={"#"}
                />
              </Box>
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Route Planner"}
                  icon={<Icon as={FcManager} w={10} h={10} />}
                  description={
                    "Lorem ipsum dolor sit amet catetur, adipisicing elit."
                  }
                  href={"/route/routeplanner"}
                />
              </Box> */}
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Route Planner V3"}
                  icon={<Icon as={FcInTransit} w={10} h={10} />}
                  description={
                    "Allocates jobs to vehicles with optimized routes and constraints."
                  }
                  href={
                    "https://maponomy2.potterstech.com/api/planner/frontend/v7.html"
                  }
                />
              </Box>
            </Flex>
          </Container>
        </Box>
      }
    />
  );
}
